import React, {useState} from 'react';
import {routesPropTypes} from '../../routes';
import SelectDropdown from "./Dropdowns/SelectDropdown";
import {getUserTypeFromLocalToken, userType} from "../../auth/accessTokenValidator";
import {faIcons} from "../../utils/iconConstants";


const SearchBar = ({routes}) => {
    const [showDropdown, setShowDropdown] = useState(false);

    const userTypeFromLocalToken = getUserTypeFromLocalToken()
    let options = routes
        .filter(option => {
            return !(option.path.includes("/:") || option.path.includes("/("))
        })
        .filter(x => {
            return userTypeFromLocalToken === userType.adminUser || x.userAccessList.includes(userTypeFromLocalToken);
        })
        .map(option => {
        return {value: option.path, label: option.path};
    });


    return <div className={'page-search-dropdown-container'}>
        <button className={'page-search-button'} title={'Search'} onClick={() => setShowDropdown(!showDropdown)}>
            <i className={faIcons.search} data-testid={"search-icon"}/>
        </button>
        {showDropdown && <SelectDropdown
            id={"search_dropdown"}
            onChange={(option) => window.location.assign(option.value)}
            options={options}
            placeholder={'Search...'}
            autoFocus={true}
        />}
    </div>
};

SearchBar.propTypes = {
    routes: routesPropTypes
};

export default SearchBar;